import { render, staticRenderFns } from "./MenuTypeForm.vue?vue&type=template&id=56ab7da8&scoped=true"
import script from "./MenuTypeForm.vue?vue&type=script&lang=js"
export * from "./MenuTypeForm.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeForm.vue?vue&type=style&index=0&id=56ab7da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab7da8",
  null
  
)

export default component.exports